import React from 'react'
import type { LotStoryArtifactVersionV1 } from '../../types/lotStory'
import type { TranslateFn } from './lotStoryLibraryTypes'

type LotStoryLibraryVersionHistoryRowSummaryProps = {
  t: TranslateFn
  version: LotStoryArtifactVersionV1
  lotStoryCardStyle: React.CSSProperties
  formatHistoryTimestamp: (value: string) => string
}

export default function LotStoryLibraryVersionHistoryRowSummary({
  t,
  version,
  lotStoryCardStyle,
  formatHistoryTimestamp
}: Readonly<LotStoryLibraryVersionHistoryRowSummaryProps>) {
  return (
    <>
      {version.summary ? (
        <div style={{ fontSize: 12, color: '#475569' }}>{version.summary}</div>
      ) : null}

      <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))' }}>
        <div style={lotStoryCardStyle}>
          <strong style={{ fontSize: 12, color: '#92400e' }}>{t('lots.story.library.history.createdAt')}</strong>
          <div style={{ fontSize: 14, color: '#111827' }}>{formatHistoryTimestamp(version.createdAt)}</div>
        </div>
        <div style={lotStoryCardStyle}>
          <strong style={{ fontSize: 12, color: '#92400e' }}>{t('lots.story.summary.generatedAt')}</strong>
          <div style={{ fontSize: 14, color: '#111827' }}>{formatHistoryTimestamp(version.projectionGeneratedAt)}</div>
        </div>
        <div style={lotStoryCardStyle}>
          <strong style={{ fontSize: 12, color: '#92400e' }}>{t('lots.story.library.detail.publishedAt')}</strong>
          <div style={{ fontSize: 14, color: '#111827' }}>
            {version.publishedAt ? formatHistoryTimestamp(version.publishedAt) : '—'}
          </div>
        </div>
      </div>
    </>
  )
}